/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Access_Entire_DescInputs */



/**
* | output |
* | --- |
* | "All event groups, including ones created later." |
*
* @param {Team_Share_Access_Entire_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_access_entire_desc = /** @type {((inputs?: Team_Share_Access_Entire_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Access_Entire_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "de") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "it") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "es") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
	return /** @type {LocalizedString} */ ("All event groups, including ones created later.")
});